/*
 * @Autor: dingxiaolin
 * @Date: 2020-03-27 21:47:21
 * @LastEditors: qiuwenjing
 * @LastEditTime: 2022-10-10 09:33:12
 */
import Vue from "vue";
import "@/style/index.scss"; // global css
import "amfe-flexible";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import store from "./vuex/index";
import { has } from './common/util/btnPermissions'
import VueClipboard from "vue-clipboard2";
import dayjs from 'dayjs';
// import Vconsole from 'vconsole';
// let vConsole = new Vconsole();
// Vue.prototype.$vConsole = vConsole;
Vue.use(VueClipboard);
import G6 from "@antv/g6/build/g6";
Vue.use(G6);
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
  ak: "6niQQjUGqGF9BlXEOibxA01kbgLGAORd",
});

import Print from "vue-print-nb";
Vue.use(Print);
import vueSwiper from 'vue-awesome-swiper'
import mixin from '@/common/util/minxi';
// import 'swiper/dist/css/swiper.css'

Vue.use(vueSwiper)
Vue.config.productionTip = false;
Vue.prototype.TITLE = process.env.TITLE 
Vue.prototype.$dayjs = dayjs;

import { waves } from "@/directive/waves/index"; // 水波纹指令
Vue.directive("waves", waves);

Vue.use(ElementUI, {
  size: "small",
});
Vue.mixin({
    methods:mixin
})
Vue.directive('has', has);
import directive from '@/directive';
Vue.use(directive);
/* 图片预览组件 */
import preview from "vue-photo-preview";
Vue.use(preview);
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.ts